// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/auth/UserManagement.css */

.user-mgmt-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
}

.user-mgmt-modal {
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  width: 90%;
  max-width: 480px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.user-mgmt-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  background: linear-gradient(135deg, #1E293B 0%, #334155 100%);
  color: white;
}

.user-mgmt-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.user-mgmt-header .close-btn {
  background: none;
  border: none;
  color: rgba(255,255,255,0.7);
  font-size: 24px;
  cursor: pointer;
  padding: 0 4px;
  line-height: 1;
}

.user-mgmt-header .close-btn:hover {
  color: white;
}

.user-mgmt-body {
  padding: 20px 24px;
  overflow-y: auto;
}

.user-mgmt-error {
  padding: 10px 14px;
  background: #FEF2F2;
  border: 1px solid #FECACA;
  border-radius: 8px;
  color: #DC2626;
  font-size: 13px;
  margin-bottom: 16px;
}

.user-mgmt-success {
  padding: 10px 14px;
  background: #F0FDF4;
  border: 1px solid #BBF7D0;
  border-radius: 8px;
  color: #16A34A;
  font-size: 13px;
  margin-bottom: 16px;
}

.user-mgmt-loading {
  text-align: center;
  color: #6B7280;
  padding: 20px;
}

.user-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
}

.user-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  background: #F8FAFC;
  border-radius: 8px;
  border: 1px solid #E2E8F0;
}

.user-row-info {
  flex: 1 1;
  min-width: 0;
}

.user-row-name {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #1E293B;
}

.user-row-email {
  display: block;
  font-size: 12px;
  color: #64748B;
}

.user-role-badge {
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 10px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  flex-shrink: 0;
}

.user-role-badge.admin {
  background: #FEF3C7;
  color: #B45309;
}

.user-role-badge.user {
  background: #E0E7FF;
  color: #4338CA;
}

.user-delete-btn {
  background: none;
  border: 1px solid #E5E7EB;
  border-radius: 6px;
  color: #9CA3AF;
  font-size: 18px;
  width: 28px;
  height: 28px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  line-height: 1;
  transition: all 0.15s;
}

.user-delete-btn:hover {
  color: #EF4444;
  border-color: #EF4444;
  background: #FEF2F2;
}

.add-user-btn {
  width: 100%;
  padding: 12px;
  background: white;
  border: 2px dashed #D1D5DB;
  border-radius: 8px;
  color: #6B7280;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
}

.add-user-btn:hover {
  border-color: #F59E0B;
  color: #D97706;
  background: #FFFBEB;
}

.add-user-form {
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  padding: 16px;
  background: #F9FAFB;
}

.add-user-form h3 {
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}

.add-user-form input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #D1D5DB;
  border-radius: 6px;
  font-size: 14px;
  margin-bottom: 8px;
  box-sizing: border-box;
}

.add-user-form input:focus {
  outline: none;
  border-color: #F59E0B;
  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.15);
}

.add-user-actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}

.add-user-actions .cancel-btn {
  flex: 1 1;
  padding: 10px;
  background: white;
  border: 1px solid #D1D5DB;
  border-radius: 6px;
  color: #4B5563;
  font-size: 14px;
  cursor: pointer;
}

.add-user-actions .confirm-btn {
  flex: 1 1;
  padding: 10px;
  background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);
  border: none;
  border-radius: 6px;
  color: white;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.add-user-actions .confirm-btn:hover {
  background: linear-gradient(135deg, #D97706 0%, #B45309 100%);
}
`, "",{"version":3,"sources":["webpack://./src/auth/UserManagement.css"],"names":[],"mappings":"AAAA,gCAAgC;;AAEhC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,6DAA6D;AAC/D","sourcesContent":["/* src/auth/UserManagement.css */\n\n.user-mgmt-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n}\n\n.user-mgmt-modal {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  width: 90%;\n  max-width: 480px;\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.user-mgmt-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  background: linear-gradient(135deg, #1E293B 0%, #334155 100%);\n  color: white;\n}\n\n.user-mgmt-header h2 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.user-mgmt-header .close-btn {\n  background: none;\n  border: none;\n  color: rgba(255,255,255,0.7);\n  font-size: 24px;\n  cursor: pointer;\n  padding: 0 4px;\n  line-height: 1;\n}\n\n.user-mgmt-header .close-btn:hover {\n  color: white;\n}\n\n.user-mgmt-body {\n  padding: 20px 24px;\n  overflow-y: auto;\n}\n\n.user-mgmt-error {\n  padding: 10px 14px;\n  background: #FEF2F2;\n  border: 1px solid #FECACA;\n  border-radius: 8px;\n  color: #DC2626;\n  font-size: 13px;\n  margin-bottom: 16px;\n}\n\n.user-mgmt-success {\n  padding: 10px 14px;\n  background: #F0FDF4;\n  border: 1px solid #BBF7D0;\n  border-radius: 8px;\n  color: #16A34A;\n  font-size: 13px;\n  margin-bottom: 16px;\n}\n\n.user-mgmt-loading {\n  text-align: center;\n  color: #6B7280;\n  padding: 20px;\n}\n\n.user-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.user-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  background: #F8FAFC;\n  border-radius: 8px;\n  border: 1px solid #E2E8F0;\n}\n\n.user-row-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.user-row-name {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  color: #1E293B;\n}\n\n.user-row-email {\n  display: block;\n  font-size: 12px;\n  color: #64748B;\n}\n\n.user-role-badge {\n  font-size: 11px;\n  font-weight: 600;\n  padding: 3px 8px;\n  border-radius: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  flex-shrink: 0;\n}\n\n.user-role-badge.admin {\n  background: #FEF3C7;\n  color: #B45309;\n}\n\n.user-role-badge.user {\n  background: #E0E7FF;\n  color: #4338CA;\n}\n\n.user-delete-btn {\n  background: none;\n  border: 1px solid #E5E7EB;\n  border-radius: 6px;\n  color: #9CA3AF;\n  font-size: 18px;\n  width: 28px;\n  height: 28px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  line-height: 1;\n  transition: all 0.15s;\n}\n\n.user-delete-btn:hover {\n  color: #EF4444;\n  border-color: #EF4444;\n  background: #FEF2F2;\n}\n\n.add-user-btn {\n  width: 100%;\n  padding: 12px;\n  background: white;\n  border: 2px dashed #D1D5DB;\n  border-radius: 8px;\n  color: #6B7280;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.add-user-btn:hover {\n  border-color: #F59E0B;\n  color: #D97706;\n  background: #FFFBEB;\n}\n\n.add-user-form {\n  border: 1px solid #E5E7EB;\n  border-radius: 8px;\n  padding: 16px;\n  background: #F9FAFB;\n}\n\n.add-user-form h3 {\n  margin: 0 0 12px 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #374151;\n}\n\n.add-user-form input {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #D1D5DB;\n  border-radius: 6px;\n  font-size: 14px;\n  margin-bottom: 8px;\n  box-sizing: border-box;\n}\n\n.add-user-form input:focus {\n  outline: none;\n  border-color: #F59E0B;\n  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.15);\n}\n\n.add-user-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 12px;\n}\n\n.add-user-actions .cancel-btn {\n  flex: 1;\n  padding: 10px;\n  background: white;\n  border: 1px solid #D1D5DB;\n  border-radius: 6px;\n  color: #4B5563;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.add-user-actions .confirm-btn {\n  flex: 1;\n  padding: 10px;\n  background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%);\n  border: none;\n  border-radius: 6px;\n  color: white;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.add-user-actions .confirm-btn:hover {\n  background: linear-gradient(135deg, #D97706 0%, #B45309 100%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
